const spanizer = require('../../viscomjs/utils/spanizer');
const preloadBlock = document.querySelector('.preloader');
let preloadState = 0;
const preloadLine = preloadBlock.querySelector('.preloader__line--fill');
const preloadNumberContainer = preloadBlock.querySelector('.preloader__number');
const preloadText = preloadBlock.querySelector('.preloader__text');


spanizer.spanizeText('.preloader__text p:first-child', {reverse: Math.random() > 0.5, center: Math.random() > 0.5});
spanizer.spanizeText('.preloader__text p:nth-child(2)', {reverse: Math.random() > 0.5, center: Math.random() > 0.5});
spanizer.spanizeText('.preloader__text p:nth-child(3)', {reverse: Math.random() > 0.5, center: Math.random() > 0.5});
spanizer.spanizeText('.preloader__text p:last-child', {reverse: Math.random() > 0.5, center: Math.random() > 0.5});

module.exports.destroy = () => {
	preloadBlock.classList.add('hide');
	setTimeout(() => {
		preloadBlock.remove();
	}, 5300);
};

module.exports.update = loader => {
    if (Math.round(loader.progress) > preloadState) {
		preloadState = Math.floor(loader.progress);
		preloadNumberContainer.innerHTML = preloadState;
    }
    preloadLine.setAttribute('style', `transform: scale(${loader.progress / 100}, 1);`);

    preloadText.classList.remove('hidden');
    if (!preloadText.classList.contains('show-text')) {
		preloadText.classList.add('show-text')
    }

};



// WEBPACK FOOTER //
// ./js/viscom/vereschagin/load/Preloader.js